import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=5f5f6208"
import script from "./editTag.vue?vue&type=script&lang=js"
export * from "./editTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports